export const AccountFavorite = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="-2 0 37 30">
		<path
			id="heart-regular"
			d="M30.688,34.142c-3.869-3.254-9.848-2.765-13.55,1-3.7-3.769-9.68-4.264-13.55-1a10.129,10.129,0,0,0-.71,14.808L14.621,60.914a3.516,3.516,0,0,0,5.034.007L31.4,48.957A10.137,10.137,0,0,0,30.688,34.142Zm-1.58,12.552L17.366,58.658a.275.275,0,0,1-.455,0L5.168,46.694a6.9,6.9,0,0,1,.489-10.089,6.787,6.787,0,0,1,9.138.7l2.343,2.39,2.343-2.39a6.783,6.783,0,0,1,9.138-.71A6.934,6.934,0,0,1,29.108,46.694Z"
			transform="translate(0 -31.978)"
		/>
	</svg>
);
